import React from 'react';
import IntegrationBack from './integration-back';
import { ModalCopySC } from '../modal/modal.styled';
import { useIntl } from 'react-intl';

type TProps = {
  onBack(): void;
};

const IntegrationHowTo: React.FC<TProps> = ({ onBack }) => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <IntegrationBack onClick={onBack} />
      <ModalCopySC>{formatMessage({ id: 'integration.how_to' })}</ModalCopySC>
      <img src={require('../../assets/jpg/integration.jpg').default} alt="" width="100%" />
    </div>
  );
};

export default IntegrationHowTo;
